import { render, staticRenderFns } from "./EditWgn.vue?vue&type=template&id=71412264&"
import script from "./EditWgn.vue?vue&type=script&lang=js&"
export * from "./EditWgn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports